import React from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

interface Props {
  id: string;
  children: JSX.Element;
  body: string;
}

const Tooltip = ({ id, children, body }: Props) => (
  <div>
    <div id={id}>{children}</div>
    <ReactTooltip anchorSelect={`#${id}`}>
      <button>{body}</button>
    </ReactTooltip>
  </div>
);

export default Tooltip;
